import { useNavigate } from "react-router-dom";
import { Button } from "../components/ui/button";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-6" data-testid="payment-cancel-page">
      <div className="max-w-md text-center">
        <h1 className="font-serif text-4xl mb-3">Payment cancelled.</h1>
        <p className="text-muted-foreground mb-8">Nothing was charged.</p>
        <Button
          data-testid="back-to-storage-btn"
          onClick={() => navigate("/storage")}
          className="rounded-full bg-primary text-primary-foreground"
        >
          Back to storage
        </Button>
      </div>
    </div>
  );
}
